import { FC, useState } from "react";

import { Button, Icon, Message, Modal } from "../../../components/common";
import { UIStatus } from "../../../types/GlobalTypes";

export const PaymentDetailsWarning: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Message
        className="cursor-pointer"
        type={UIStatus.WARNING}
        onClick={() => setIsOpen(true)}
        text={
          <div className="flex gap-2">
            <Icon icon="warning" size={24} className="text-gray-500" />

            <div className="flex flex-col gap-2">
              Pay Only Trusted and Verified Recipients.
              <span className="!theme-text-default font-bold">Learn More</span>
            </div>
          </div>
        }
      />

      <Modal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        title="Before proceeding with payment, please ensure"
      >
        <div className="flex flex-col gap-3">
          <div>1. You are paying someone you know and trust.</div>
          <div>
            2. Avoid prepayments for goods or services from unfamiliar sources,
            especially posts in online marketplaces like Facebook groups.
          </div>
          <div>3. Always verify the legitimacy of the recipient.</div>

          <Button
            block
            className="mt-2"
            variant={Button.variant.PRIMARY}
            onClick={() => setIsOpen(false)}
          >
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};
